import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import SplitType from "split-type";

gsap.registerPlugin(ScrollTrigger);

/**
 * Découpe un élément en lignes visuelles, préserve le HTML
 */
function splitIntoLines(el) {
  // Utiliser SplitType qui préserve le HTML
  const split = new SplitType(el, { types: "lines", lineClass: "reveal-line" });

  const lines = split.lines;
  if (!lines || !lines.length) return [];

  // S'assurer que chaque ligne a overflow hidden
  lines.forEach((line) => {
    line.style.display = "block";
    line.style.overflow = "hidden";
  });

  return lines;
}

/**
 * Animation GSAP
 */
function animateLines(el, immediate = false) {
  const runAnimation = () => {
    const lines = splitIntoLines(el);
    if (!lines || !lines.length) return;

    // Définir l'état initial pour toutes les lignes
    gsap.set(lines, {
      yPercent: 100,
      opacity: 0
    });

    // Animer vers l'état final
    gsap.to(lines, {
      yPercent: 0,
      opacity: 1,
      duration: 0.8,
      ease: "power3.out",
      stagger: 0.15,
      delay: immediate ? 0.1 : 0, // Petit délai pour éviter le flash sur immediate
      scrollTrigger: immediate ? undefined : {
        trigger: el,
        start: "top 80%",
        toggleActions: "play none none none",
      },
    });
  };

  if (immediate) {
    requestAnimationFrame(() => requestAnimationFrame(runAnimation));
  } else {
    runAnimation();
  }
}

/**
 * Init
 */
function initTextReveal() {
  document.querySelectorAll(".reveal-text.immediate").forEach((el) => animateLines(el, true));
  document.querySelectorAll(".reveal-text.on-scroll").forEach((el) => animateLines(el, false));
}

// Exposer la fonction globalement pour Barba.js
window.initTextReveal = initTextReveal;

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initTextReveal);
} else {
  initTextReveal();
}
